import { useStore } from "zustand";
import { NotificationsRepository } from "@/api/notifications/repository";
import { NotificationsService } from "@/api/notifications/service";
import { PAGINATION_SIZE } from "@/constants/index";
import { useAppStore } from "@/store/app/slice";
import type { INotificationsModelState } from "./NotificationsCenter";
import { NotificationsCenter } from "./NotificationsCenter";

export type { INotificationsModelState } from "./NotificationsCenter";

export const notificationsCenter = new NotificationsCenter({
  // No `abort` option: the model cancels its own requests
  repository: new NotificationsRepository(new NotificationsService()),
  getAccessToken: () => useAppStore.getState().accessToken,
  pageSize: PAGINATION_SIZE,
});

export const useNotifications = <T>(
  selector: (s: INotificationsModelState) => T,
): T => useStore(notificationsCenter.store, selector);
